import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';

/**
 * Local dev: backend resolves tenant using the X-Forwarded-Host header (see backend RequestHostExtractor).
 * Browser Host is localhost and does not match tenants.domain — never set tenantForwardedHost in production.
 */
export const tenantDevHostInterceptor: HttpInterceptorFn = (req, next) => {
  const host = environment.tenantForwardedHost?.trim();
  if (!host || !req.url.includes('/api')) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { 'X-Forwarded-Host': host } }));
};
